var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseModal',{staticClass:"popup",attrs:{"id":`${_vm.moduleName}-${_vm.instanceId}`,"show-on-desk":_vm.showOnDesk,"show-on-mobile":_vm.showOnMobile}},[_c('div',{staticClass:"popup__wrapper"},[_c('IconClose',{attrs:{"color":"#000000","title":"Fechar","width":"24","height":"24"}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }